import { Alert, Snackbar } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import langDocumentFile from '../langs/langDocumentFile';

type CDocumentDownloadErrorSnackbarProps = {
	// `'404'` and `'no_current_document'` are the two known string variants
	// (rendered with translated copy). Any other thrown `Error` falls through to
	// the catch-all branch which displays the message inline.
	downloadError: '404' | 'no_current_document' | Error | null;
	onClose: () => void;
};

const CDocumentDownloadErrorSnackbar = (props: CDocumentDownloadErrorSnackbarProps) => {
	const { downloadError, onClose } = props;

	const { t } = useTranslation();

	return (
		<Snackbar
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			open={!!downloadError}
			onClose={() => onClose()}

			// autoHideDuration={3000}
		>
			<Alert onClose={() => onClose()} severity="error" sx={{ width: '100%' }}>
				{downloadError === '404' ? (
					<>{t(langDocumentFile.downloading_error_404.tag)}</>
				) : downloadError === 'no_current_document' ? (
					<>{t(langDocumentFile.downloading_error_no_current_document.tag)}</>
				) : downloadError instanceof Error ? (
					downloadError.message
				) : (
					downloadError
				)}
			</Alert>
		</Snackbar>
	);
};

export default CDocumentDownloadErrorSnackbar;
